module.exports = __webpack_public_path__ + "fonts/Benzin-Regular.1b0edd6.woff";